import { useState, useCallback } from "react";
import PropTypes from "prop-types";

const ComingSoon = ({ onAuthenticated }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const correctPassword = import.meta.env.VITE_ADMIN_PASSWORD;

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!password.trim()) {
        setError("Please enter a password");
        return;
      }

      setError("");
      setIsLoading(true);

      try {
        await new Promise((resolve) => setTimeout(resolve, 500));

        if (password === correctPassword) {
          localStorage.setItem("isAuthenticated", "true");
          onAuthenticated(true);
        } else {
          setError("Incorrect password");
          setPassword("");
        }
      } catch (error) {
        console.error("Authentication error:", error);
        setError("Authentication failed");
      } finally {
        setIsLoading(false);
      }
    },
    [password, correctPassword, onAuthenticated]
  );

  const handleCancel = () => {
    setShowPassword(false);
    setPassword("");
    setError("");
  };

  return (
    <div className="fixed inset-0 bg-black flex justify-center items-center">
      <h1
        className="text-white text-6xl font-bold transform transition-all 
                     duration-700 hover:scale-105"
      >
        Coming Soon
      </h1>

      {!showPassword ? (
        <button
          className="fixed bottom-5 right-5 px-4 py-2 text-white 
        bg-[#009fd6] hover:opacity-80 rounded-full hover:text-black transition-all duration-300 
        ease-in-out transform hover:-translate-y-1"
          onClick={() => setShowPassword(true)}
        >
          Admin Login
        </button>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="fixed bottom-5 right-5 flex flex-col gap-2"
        >
          <div className="flex gap-2">
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) setError("");
              }}
              placeholder="Enter password"
              disabled={isLoading}
              className="px-3 py-2 bg-transparent border border-white text-white 
                       placeholder-gray-400 focus:outline-hidden focus:ring-2 
                       focus:ring-white disabled:opacity-50"
              autoFocus
            />
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 bg-[#009fd6] text-white hover:opacity-80 rounded-full
             transition-all duration-300 disabled:opacity-50 
             disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Processing
                </>
              ) : (
                "Enter"
              )}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              disabled={isLoading}
              className="px-4 py-2 bg-gray-700 text-white hover:opacity-80 rounded-full
             transition-all duration-300 disabled:opacity-50 
             disabled:cursor-not-allowed"
            >
              Cancel
            </button>
          </div>
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </form>
      )}
    </div>
  );
};

ComingSoon.propTypes = {
  onAuthenticated: PropTypes.func.isRequired,
};

export default ComingSoon;
